import axios from 'axios';
import { lenientParse, isNumberCellEmpty, createDateAsUTC } from '../../services/items';

export const getForwardCurveDefinitions = async (itemId) => {
    const response = await axios.get(`/forward-curve/${itemId}/sub-forward-curves`);
    return response.data;
};

export const createForwardCurveData = (forwardCurveId, payload) =>
    axios.post(`/forward-curve/${forwardCurveId}/create-forward-curve-data`, payload);

export const getForwardCurveData = async (forwardCurveId, payload) => {
    const formattedPayload = {
        ...payload,
        transactionDateFrom: payload.startDateFrom,
        transactionDateTo: payload.startDateTo,
    };

    const response = await axios.post(`/forward-curve/${forwardCurveId}/forward-curve-data`, formattedPayload);

    return response.data;
};

export const deleteForwardCurveData = () => {};

export const updateForwardCurveData = (forwardCurveId, payload) =>
    axios.put(`/forward-curve/${forwardCurveId}/update-forward-curve-data`, payload);

export const deleteAllForwardCurveData = (forwardCurveId) =>
    axios.delete(`/forward-curve/${forwardCurveId}/delete-all-forward-curve-data`);

export const formatParsedNewForwardCurveData = (data, peakPeriods) => {
    return data.map(({ transactionDate, peakPeriodLabelId, deliveryDate, updateDateTime, price }) => {
        return {
            transactionDate: transactionDate ? createDateAsUTC(lenientParse(transactionDate)) : null,
            peakPeriodLabelId: peakPeriodLabelId
                ? peakPeriods.find((item) => item.description === peakPeriodLabelId).id
                : null,
            deliveryDate: deliveryDate ? createDateAsUTC(lenientParse(deliveryDate)) : null,
            price: isNumberCellEmpty(price),
            updateDateTime: updateDateTime ? createDateAsUTC(lenientParse(updateDateTime)) : null,
        };
    });
};
export const createForwardCurveDefinition = async (payload) => {
    const response = await axios.post('/forward-curve/create', payload);
    return response.data;
};

export const createForwardCurveOptions = (forwardCurveId, payload) =>
    axios.post(`/forward-curve/${forwardCurveId}/create-options`, payload);

export const getForwardCurveOptions = async (forwardCurveId, payload) => {
    const formattedPayload = {
        ...payload,
        transactionDateFrom: payload.startDateFrom,
        transactionDateTo: payload.startDateTo,
    };

    const response = await axios.post(`/forward-curve/${forwardCurveId}/forward-curve-options`, formattedPayload);

    return response.data;
};

export const deleteForwardCurveOptions = () => {};

export const updateForwardCurveOptions = (forwardCurveId, payload) =>
    axios.put(`/forward-curve/${forwardCurveId}/update-options`, payload);

export const deleteAllForwardCurveOptions = (forwardCurveId) =>
    axios.delete(`/forward-curve/${forwardCurveId}/delete-all-options`);

export const formatParsedNewForwardCurveOptions = (data, peakPeriods) => {
    return data.map(
        ({
            transactionDate,
            peakPeriodId,
            deliveryDate,
            updateDateTime,
            expiration,
            price,
            strikePrice,
            bid,
            ask,
            settle,
            vol,
            ...rest
        }) => {
            return {
                ...rest,
                peakPeriodId: peakPeriodId ? peakPeriods.find((item) => item.description === peakPeriodId).id : null,
                transactionDate: transactionDate ? createDateAsUTC(lenientParse(transactionDate)) : null,
                deliveryDate: deliveryDate ? createDateAsUTC(lenientParse(deliveryDate)) : null,
                updateDateTime: updateDateTime ? createDateAsUTC(lenientParse(updateDateTime)) : null,
                expiration: expiration ? createDateAsUTC(lenientParse(expiration)) : null,
                price: isNumberCellEmpty(price),
                strikePrice: isNumberCellEmpty(strikePrice),
                bid: isNumberCellEmpty(bid),
                ask: isNumberCellEmpty(ask),
                settle: isNumberCellEmpty(settle),
                vol: isNumberCellEmpty(vol),
            };
        }
    );
};

export const editForwardCurve = (payload) => {
    return axios.put('/forward-curve/modify-forward-curves', payload);
};
